export default __webpack_public_path__ + "locales/cs/CreateEditRoomDialog.json?hash=c7f7a0426d4e68e14785ed2add3879b4";